import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const addLike = async (publicationId) => {
  const like = await request(
    getEndpoint("publication", "likePublication", publicationId),
  );
  return like.data;
};

export const removeLike = async (publicationId) => {
  const like = await request(
    getEndpoint("publication", "unlikePublication", publicationId),
  );
  return like.data;
};

export const getLike = async (publicationId) => {
  const like = await request(
    getEndpoint("publication", "isLikedByMe", publicationId),
  );
  return like.data;
};
